import React, {Component} from 'react'
import Base from '../BaseComponent'

import {
  withRouter
} from 'react-router-dom';

class Back extends Component {


  render () {

  	/*
		TODO: how to go back if this is the first page (or use an overlay)
	*/

    return (

        <Base {...this.props}>
            <a href="#" onClick={(ev) => { ev.preventDefault(); this.props.history.go(-1);}}>
                { this.props.children }
            </a>
        </Base>
    )
  }
}

export default withRouter(Back)



// WEBPACK FOOTER //
// ./src/js/components/Back/Back.jsx